// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1w3d5","range":"MonthRangeSwitch_range__2PqAb","disabled":"MonthRangeSwitch_disabled__2Zfy8"};